import { AlphaLBoxIcon } from './AlphaLBoxIcon';

/**
 * author: GreenTurtwig
 * id 7E7BF31C-C3FA-4744-B214-FF8D15753ED5
 * name alpha-l-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-l-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetLBoxIcon = AlphaLBoxIcon;
export default AlphabetLBoxIcon